///
/// EarthBrowser
///
/// Radar Browser Feature
///
/// Manages radar browser window lifecycle and command palette registration
///
/// Created by Matt Giger on 1/5/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useEffect } from 'react'
import { Radio } from 'lucide-react'
import { RadarBrowserRenderer } from '@/components/features/radar-browser/RadarBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const RADAR_WINDOW_ID = 'radar-browser'
const RADAR_WINDOW_WIDTH = 700
const RADAR_WINDOW_HEIGHT = 500

export function RadarBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const radarWindow = datasetWindows[RADAR_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'radar-browser',
			command: {
				id: 'radar',
				title: 'Radar',
				icon: <Radio className="w-4 h-4 text-green-400" />,
				category: 'Datasets',
				enabled: true,
				onSelect: () => {
					openOrRestoreWindow(
						dispatch,
						datasetWindows,
						RADAR_WINDOW_ID,
						{
							id: RADAR_WINDOW_ID,
							title: 'Radar',
							windowType: 'radar',
							x: 140,
							y: 140,
							width: RADAR_WINDOW_WIDTH,
							height: RADAR_WINDOW_HEIGHT,
							isMaximized: false,
							isVisible: true,
						}
					)
				}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!radarWindow) {
		return null
	}

	return (
		<RadarBrowserRenderer
			windowId={RADAR_WINDOW_ID}
			windowState={radarWindow}
		/>
	)
}
